module.exports = __webpack_public_path__ + "img/who_app_illustration.322c4584.svg";